import { defineComponent as b, resolveComponent as d, openBlock as e, createElementBlock as a, createElementVNode as o, normalizeStyle as w, renderSlot as y, createVNode as i, withCtx as x, createTextVNode as v, toDisplayString as S, Fragment as g, renderList as m, createBlock as _, createCommentVNode as V } from "vue";
import { _ as B } from "../../../VHeadline.vue_vue_type_script_lang-186a5340.js";
import $ from "../../atoms/VIcon/VIcon.js";
import k from "../../atoms/VText/VText.js";
import { S as T } from "../../../Spacing-695d3b19.js";
import { _ as I } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../composables/useShowPriceDisclaimer.js";
import "../../../composables/useSpacingClass.js";
import "../../../utils/tailwindUnitsConverter.js";
const z = b({
  name: "VRatingBanner",
  components: {
    VHeadline: B,
    VIcon: $,
    VText: k
  },
  props: {
    ratingTitle: {
      type: String,
      default: ""
    },
    rating: {
      type: Number,
      default: 0
    },
    bgImageUrl: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const n = Math.min(Math.max(t.rating, 0), 5), s = n % 1, l = n - s, c = s > 0;
    return {
      fullStars: l,
      halfStar: c,
      emptyStars: 5 - l - (c ? 1 : 0),
      ratingText: n.toString().replace(".", ","),
      Spacing: T
    };
  }
});
const C = { class: "hobi-rating-banner tw-h-20 tw-bg-gray-200" }, A = { class: "hobi-rating-banner__description tw-flex-1 tw-h-full" }, F = { class: "hobi-rating-banner__rating tw-text-center" }, M = { class: "hobi-rating-banner__rating-stars tw-flex tw-justify-center" }, N = {
  key: 0,
  class: "hobi-rating-banner__rating-stars--half tw-relative"
};
function H(t, u, n, s, l, c) {
  const f = d("VText"), h = d("VHeadline"), r = d("VIcon");
  return e(), a("div", C, [
    o("div", {
      class: "hobi-rating-banner__mask tw-h-full tw-bg-no-repeat tw-bg-right tw-flex",
      style: w({
        backgroundImage: `url('${t.bgImageUrl}')`
      })
    }, [
      o("div", A, [
        y(t.$slots, "default", {}, void 0, !0)
      ]),
      o("div", F, [
        i(f, {
          as: "span",
          color: "white",
          center: !0,
          weight: "bold",
          size: "xxs",
          tag: "div",
          class: "hobi-rating-banner__rating-title"
        }, {
          default: x(() => [
            v(S(t.ratingTitle), 1)
          ]),
          _: 1
        }),
        i(h, {
          as: "span",
          title: `${t.ratingText} / 5`,
          color: "white",
          "top-spacing": t.Spacing.xs
        }, null, 8, ["title", "top-spacing"]),
        o("div", M, [
          (e(!0), a(g, null, m(t.fullStars, (p) => (e(), _(r, {
            key: `fullStar${p}`,
            symbol: "star-rounded-full",
            color: "white",
            viewBox: "0 0 24 24",
            size: "10px"
          }))), 128)),
          t.halfStar ? (e(), a("div", N, [
            i(r, {
              symbol: "star-rounded-full",
              color: "#FFCBA6",
              viewBox: "0 0 24 24",
              size: "10px"
            }),
            i(r, {
              class: "hobi-rating-banner__rating-stars--half--mask tw-absolute tw-top-0 tw-left-0",
              symbol: "star-rounded-half",
              color: "white",
              viewBox: "0 0 24 24",
              size: "10px"
            })
          ])) : V("", !0),
          (e(!0), a(g, null, m(t.emptyStars, (p) => (e(), _(r, {
            key: `emptyStar${p}`,
            symbol: "star-rounded-full",
            color: "#FFCBA6",
            viewBox: "0 0 24 24",
            size: "10px"
          }))), 128))
        ])
      ])
    ], 4)
  ]);
}
const J = /* @__PURE__ */ I(z, [["render", H], ["__scopeId", "data-v-e5e866d8"]]);
export {
  J as default
};
